module.exports = __webpack_public_path__ + "static/media/alchemist.c698737a.png";